import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  min-height: 100vh;
  padding: 50px 0;
  align-items: center;
  justify-content: center;
`;

const Wrapper = styled.div`
  text-align: center;
  width: 404px;
  padding: 0 10px;
`;

const Logo = styled.img`
  margin-bottom: 32px;
`;

const FooterLinkStyles = `
  margin-bottom: 16px;
  font-family: "Lato","Lucida Grande","Helvetica Neue",Helvetica,Arial,Verdana,sans-serif;
  font-size: 14px;
`;

const SignUp = styled.p`
  ${FooterLinkStyles}
`;

const BusinessAccount = styled.p`
  ${FooterLinkStyles}
`;

const NeedHelpMessage = styled.p`
  ${FooterLinkStyles}
`

export { Container, Wrapper, Logo, FooterLinkStyles, SignUp, BusinessAccount, NeedHelpMessage };



// WEBPACK FOOTER //
// ./src/login/login.component.styles.js